
// Animation variants for consistent usage

export const fadeIn = (direction: 'up' | 'down' | 'left' | 'right' = 'up', delay: number = 0, duration: number = 0.5) => {
  return {
    hidden: {
      opacity: 0,
      x: direction === 'left' ? 50 : direction === 'right' ? -50 : 0,
      y: direction === 'up' ? 50 : direction === 'down' ? -50 : 0,
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        delay,
        duration,
        ease: 'easeOut',
      },
    },
  };
};

export const slideIn = (direction: 'up' | 'down' | 'left' | 'right', delay: number = 0, duration: number = 0.5) => {
  return {
    hidden: {
      opacity: 0,
      x: direction === 'left' ? '-100%' : direction === 'right' ? '100%' : 0,
      y: direction === 'up' ? '100%' : direction === 'down' ? '-100%' : 0,
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        delay,
        duration,
        type: 'spring',
        damping: 20,
        stiffness: 100,
      },
    },
  };
};

export const staggerContainer = (staggerChildren: number = 0.1, delayChildren: number = 0) => {
  return {
    hidden: {},
    visible: {
      transition: {
        staggerChildren,
        delayChildren,
      },
    },
  };
};

export const getReducedMotionVariants = (baseVariants: any, reducedMotion: boolean) => {
  if (reducedMotion) {
    return {
      hidden: { opacity: 0 },
      visible: { 
        opacity: 1, 
        transition: { duration: 0.2 } 
      }
    };
  }
  
  return baseVariants;
};
